import React, { useState, useEffect, useRef } from 'react'
import './tickets.css'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { ImSpinner2 } from 'react-icons/im'
import { FaTimes } from 'react-icons/fa'

const Uploaddocs = () => {
  const [selectedMode, setSelectedMode] = useState('')
  const { claimNumber } = useParams()
  const navigate = useNavigate()
  const [modes, setModes] = useState([])
  const [loading, setLoading] = useState(false)
  const [isMobileView, setIsMobileView] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [proceedCalled, setProceedCalled] = useState(false) // To track if proceed was already called

  const [userLocation, setUserLocation] = useState({
    latitude: null,
    longitude: null
  })

  // States for each section
  const [uploadingSections, setUploadingSections] = useState([])
  const [uploadedImages, setUploadedImages] = useState({})
  const [previewImages, setPreviewImages] = useState({})
  const [showPreviewModal, setShowPreviewModal] = useState(false)
  const [selectedPreviewImage, setSelectedPreviewImage] = useState('')
  
  // New state to track successful uploads
  const [successfullyUploadedSections, setSuccessfullyUploadedSections] = useState({})

  const fileInputRefs = useRef({})
  const previewIcon = `${process.env.PUBLIC_URL}/preview.png`
  const ticket = `${process.env.PUBLIC_URL}/ticket.png`
  const uploadIcon = `${process.env.PUBLIC_URL}/claim-landing/upload.png`

  // Main sections
  const sections = [
    'Front',
    'Front Left',
    'Left',
    'Back Left',
    'Back',
    'Back Right',
    'Right',
    'Front Right',
    'Outer Windshield',
    'Inner Windshield',
    'Odometer',
    'Chassis',
    'Engine',
    'RC'
  ]

  const getDisplayName = (section) => {
    return section === 'Engine' ? 'Engine No.' : section;
  }

  // Format section name
  const formatSectionName = section => {
    const sectionMapping = {
      'Front': 'front_side_captured_image',
      'Front Left': 'front_left_side_captured_image',
      'Left': 'left_side_captured_image',
      'Back Left': 'back_left_side_captured_image',
      'Back': 'back_side_captured_image',
      'Back Right': 'back_right_side_captured_image',
      'Right': 'right_side_captured_image',
      'Front Right': 'front_right_side_captured_image',
      'Outer Windshield': 'outer_windshield_captured_image',
      'Inner Windshield': 'inner_windshield_captured_image',
      'Odometer': 'odometer_captured_image',
      'Chassis': 'chassis_captured_image',
      'Engine': 'engine_captured_image',
      'RC': 'RC_captured_image'
    }
    return sectionMapping[section] || section.toLowerCase().replace(/[\s-]/g, '_') + '_captured_image'
  }

  // Get section ID
  const getSectionId = (section) => {
    const sectionIdMap = {
      'Front': 1,
      'Front Left': 2,
      'Left': 3,
      'Back Left': 4,
      'Back': 5,
      'Back Right': 6,
      'Right': 7,
      'Front Right': 8,
      'Outer Windshield': 9,
      'Inner Windshield': 15,
      'Odometer': 17,
      'Chassis': 19,
      'Engine': 20,
      'RC': 21
    }
    return sectionIdMap[section] || 0
  }

  // Format timestamp to "YYYY-MM-DD HH:mm:ss" in IST
const formatTimestamp = () => {
  const now = new Date();
  
  // Convert to IST (UTC+5:30)
  const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
  const istTime = new Date(now.getTime() + istOffset);
  
  const year = istTime.getUTCFullYear();
  const month = String(istTime.getUTCMonth() + 1).padStart(2, '0');
  const day = String(istTime.getUTCDate()).padStart(2, '0');
  const hours = String(istTime.getUTCHours()).padStart(2, '0');
  const minutes = String(istTime.getUTCMinutes()).padStart(2, '0');
  const seconds = String(istTime.getUTCSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

  // Function to send completion email
const sendCompletionEmail = async (claimNumber) => {
  try {
    const emailResponse = await axios.post(
      '/process_data/send-upload-complete-email',
      {
        audit_id: claimNumber,
        status: 'upload_complete',
        message: 'Claim Images Upload Completed in Phase-2',
        step: 'Image'
      }
    );

    if (emailResponse.status === 200 || emailResponse.status === 201) {
      console.log('Email notification sent successfully');
      setEmailSent(true);
    }
  } catch (error) {
    console.error('Error sending completion email:', error);
    // Don't throw error, just log it
  }
};

  // Function to check if all images are uploaded
  const checkAllImagesUploaded = () => {
    // Check if all sections have successfully uploaded images
    const allUploaded = sections.every(section => successfullyUploadedSections[section]);
    return allUploaded;
  };

  // Proceed handler function - Called automatically when all images are uploaded
  const handleProceed = async () => {
    try {
      console.log('All images uploaded. Proceeding to update token...');
      
      const result2 = await axios.post('/create_audit/update_token', {
        audit: claimNumber,
        processed: 1,
        status: 'processing'
      });
      
      if (claimNumber && !emailSent) {
        await sendCompletionEmail(claimNumber);
      }
      
      console.log('Token update result:', result2.data);
      setProceedCalled(true);
      
    } catch (error) {
      console.error('Error in handleProceed:', error);
    }
  };

  // Effect to check when all images are uploaded and call handleProceed
  useEffect(() => {
    const allUploaded = checkAllImagesUploaded();
    
    if (allUploaded && !proceedCalled) {
      console.log('All images have been uploaded! Calling handleProceed...');
      handleProceed();
    }
  }, [successfullyUploadedSections]); // Run when successfullyUploadedSections changes

  // Get current location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          })
        },
        (error) => {
          console.error("Location error:", error)
        }
      )
    }
  }, [])

  // Check mobile view
  useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 768)
    }

    checkMobileView()
    window.addEventListener('resize', checkMobileView)

    return () => {
      window.removeEventListener('resize', checkMobileView)
    }
  }, [])

  // Fetch mode
  useEffect(() => {
    const fetchMode = async () => {
      try {
        const response = await fetch('/create_audit/get_mode', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ claimNumber: claimNumber })
        })

        const data = await response.json()
        console.log('Mode data:', data)

        if (response.ok) {
          const modeValue = data.mode
          const capitalizedMode =
            modeValue.charAt(0).toUpperCase() + modeValue.slice(1) + ' Mode'
          setModes([capitalizedMode])
          setSelectedMode(capitalizedMode)
        } else {
          console.error('Error fetching mode:', data)
        }
      } catch (error) {
        console.error('Fetch mode error:', error)
      }
    }

    if (claimNumber) {
      fetchMode()
    }
  }, [claimNumber])

  // Fetch already uploaded images
  useEffect(() => {
    if (claimNumber) {
      fetchAlreadyUploadedImages();
    }
  }, [claimNumber]);

  // Fetch already uploaded images
  const fetchAlreadyUploadedImages = async () => {
    try {
      console.log('Fetching uploaded images for:', claimNumber);
      
      const response = await axios.post('/process_data/get-uploaded-car-images', {
        claimNumber: claimNumber
      });

      console.log('API Response:', response.data);
      
      if (response.data.success) {
        const imagesMap = {};
        const uploadedSections = {};
        
        response.data.images.forEach(img => {
          console.log('Image data:', img);
          
          let sectionName = '';
          
          if (img.section) {
            sectionName = img.section;
            console.log('Using backend section:', sectionName);
          }
          else if (img.fileName) {
            const parts = img.fileName.replace('.jpg', '').replace('.jpeg', '').replace('.png', '').split('_');
            if (parts.length >= 2) {
              const sectionKey = parts[1];
              
              const sectionMap = {
                'front': 'Front',
                'front_left': 'Front Left',
                'left': 'Left',
                'back_left': 'Back Left',
                'back': 'Back',
                'back_right': 'Back Right',
                'right': 'Right',
                'front_right': 'Front Right',
                'outer_windshield': 'Outer Windshield',
                'inner_windshield': 'Inner Windshield',
                'odometer': 'Odometer',
                'chassis': 'Chassis',
                'engine': 'Engine',
                'RC': 'RC'
              };
              
              sectionName = sectionMap[sectionKey] || sectionKey;
              console.log('Extracted section from filename:', sectionName);
            }
          }
          
          if (sectionName && img.url) {
            imagesMap[sectionName] = img.url;
            uploadedSections[sectionName] = true;
            console.log('Mapped:', sectionName, '=>', img.url.substring(0, 50) + '...');
          }
        });
        
        setUploadedImages(imagesMap);
        setSuccessfullyUploadedSections(uploadedSections);
        console.log('Final uploadedImages:', imagesMap);
        
        // Check if all images are already uploaded
        const allUploaded = sections.every(section => uploadedSections[section]);
        if (allUploaded && !proceedCalled) {
          console.log('All images were already uploaded from backend');
          handleProceed();
        }
        
        sections.forEach(section => {
          console.log(`Checking ${section}:`, imagesMap[section] ? ' Has image' : ' No image');
        });
      } else {
        console.log('No images found');
      }
    } catch (error) {
      console.error('Error fetching uploaded images:', error);
    }
  };

  // Convert base64 to Blob (EXACTLY like CameraModule)
  const base64ToBlob = (base64, contentType = 'image/jpeg') => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  // UPDATED UPLOAD FUNCTION with metadata fail handling
  const handleFileUpload = async (file, section) => {
    if (!file) return

    try {
      setUploadingSections(prev => [...prev, section])

      const reader = new FileReader()

      reader.onloadend = async () => {
        const fileExtension = file.name.split('.').pop()
        const contentType = file.type

        // Create preview URL
        const previewUrl = URL.createObjectURL(file)
        setPreviewImages(prev => ({ ...prev, [section]: previewUrl }))

        // Current time
        const clickedTime = formatTimestamp();

        // File name format
        const formattedSection = formatSectionName(section)
        const fileExtensionLower = fileExtension.toLowerCase()
        const finalExtension = fileExtensionLower === 'jpg' ? 'jpeg' : fileExtensionLower
        const fileName = `${claimNumber}_${formattedSection}.${finalExtension}`
        
        // Get base64 string
        const base64String = reader.result.split(',')[1]

        // Validate base64
        if (!base64String || base64String.length < 1000) {
          console.error("Invalid image data for:", section);
          alert(`Invalid image data for ${section}. Please try again.`);
          setUploadingSections(prev => prev.filter(s => s !== section))
          setPreviewImages(prev => {
            const newPreviewImages = { ...prev }
            delete newPreviewImages[section]
            return newPreviewImages
          })
          return;
        }

        // Convert Base64 → Blob (like CameraModule)
        const blob = base64ToBlob(base64String, contentType);

        if (blob.size < 1000) {
          console.error("Blob too small, skipping upload:", blob.size, section);
          alert(`Image file too small for ${section}. Please select a proper image.`);
          setUploadingSections(prev => prev.filter(s => s !== section))
          setPreviewImages(prev => {
            const newPreviewImages = { ...prev }
            delete newPreviewImages[section]
            return newPreviewImages
          })
          return;
        }

        try {
          // Create FormData for claimImages
          const claimFormData = new FormData();
          claimFormData.append("blobName", `claimImages/${fileName}`);
          claimFormData.append("file", blob, fileName);
          claimFormData.append("contentType", contentType);

          // Create FormData for auditImages
          const auditFormData = new FormData();
          auditFormData.append(
            "blobName",
            `Insurance_Inspection/auditImages/${fileName}`
          );
          auditFormData.append("file", blob, fileName);
          auditFormData.append("contentType", contentType);

          // Upload both in parallel (like CameraModule)
          const [claimResponse, auditResponse] = await Promise.all([
            axios.post("/process_data/upload-img", claimFormData, {
              headers: { "Content-Type": "multipart/form-data" },
              maxContentLength: Infinity,
              maxBodyLength: Infinity,
            }),
            axios.post("/process_data/upload-img-others", auditFormData, {
              headers: { "Content-Type": "multipart/form-data" },
              maxContentLength: Infinity,
              maxBodyLength: Infinity,
            }),
          ]);

          // Both successful
          if (claimResponse.status === 200 && auditResponse.status === 200) {
            const uploadedUrl = claimResponse.data.url;
            
            // Update uploaded images state
            setUploadedImages(prev => ({ ...prev, [section]: uploadedUrl }))
            
            console.log(`✅ Image uploaded successfully for ${section}:`, uploadedUrl)

            // Try to save metadata
            try {
              const adjustedId = getSectionId(section)
              const imageName = section.toLowerCase().replace(/\s+/g, '_')
              
              const formData = new FormData()
              formData.append('clickedTime', clickedTime)
              formData.append('name', imageName)
              formData.append('id', adjustedId.toString())
              formData.append('claimNumber', claimNumber)
              formData.append('latitude', userLocation.latitude?.toString() || '0')
              formData.append('longitude', userLocation.longitude?.toString() || '0')
              formData.append('azure_image_name', fileName)

              const response = await axios.post("/process_data/upload_process_store_individually", formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              
              console.log("✅ Metadata saved for", section, response.data)
              
              // ONLY mark as successfully uploaded if metadata save was successful
              setSuccessfullyUploadedSections(prev => ({ ...prev, [section]: true }))
              
            } catch (metadataError) {
              console.error(`❌ Metadata save failed for ${section}:`, metadataError)
              // Metadata save failed - DO NOT mark as successfully uploaded
              // Upload button will remain enabled
              alert(`Image uploaded but metadata save failed for ${section}. Please click Upload again to retry metadata save.`);
            }
            
          } else {
            console.error("❌ Image upload failed:", {
              claimStatus: claimResponse?.status,
              auditStatus: auditResponse?.status,
            });
            alert(`Failed to upload image for ${section}. Please try again.`);
          }
        } catch (uploadError) {
          console.error(`❌ Network/upload error for ${section}:`, uploadError);
          
          // Check if it's a network error
          if (uploadError.code === 'ECONNABORTED' || 
              uploadError.message?.includes('network') || 
              uploadError.message?.includes('timeout') ||
              !uploadError.response) {
            
            console.log(`🔄 Network error detected for ${section}, upload button will remain enabled`);
            // Network error - upload button will remain enabled
            alert(`Network error while uploading ${section}. Please try again.`);
          } else {
            alert(`Error uploading image for ${section}. Please try again.`);
          }
        }

        // Always clear preview images
        setPreviewImages(prev => {
          const newPreviewImages = { ...prev }
          delete newPreviewImages[section]
          return newPreviewImages
        })

      };

      reader.readAsDataURL(file)
    } catch (error) {
      console.error(`❌ Error uploading file for ${section}:`, error)
      alert(`Error uploading image for ${section}. Please try again.`)
      setPreviewImages(prev => {
        const newPreviewImages = { ...prev }
        delete newPreviewImages[section]
        return newPreviewImages
      })
    } finally {
      setUploadingSections(prev => prev.filter(s => s !== section))
    }
  }

  // Trigger file input
  const triggerFileInput = (section) => {
    if (fileInputRefs.current[section]) {
      fileInputRefs.current[section].click()
    }
  }

  // Handle file input change
  const handleFileInputChange = (event, section) => {
    const file = event.target.files[0]
    if (file) {
      handleFileUpload(file, section)
    }
    event.target.value = null
  }

  // Open preview in new tab
  const openImageInNewTab = (section) => {
    const imageUrl = uploadedImages[section]
    if (imageUrl) {
      window.open(imageUrl, '_blank', 'noopener,noreferrer');
    }
  }

  // Close preview modal
  const closePreviewModal = () => {
    setShowPreviewModal(false)
    setSelectedPreviewImage('')
  }

  // Check if section has image
  const hasImage = (section) => {
    return successfullyUploadedSections[section] || false;
  }

  // Check if section is uploading
  const isUploading = (section) => {
    return uploadingSections.includes(section)
  }

  // Check if section has temporary preview
  const hasTemporaryPreview = (section) => {
    return previewImages[section] && !successfullyUploadedSections[section];
  }

  // Get button content
  const getButtonContent = (section) => {
    if (isUploading(section)) {
      return {
        text: 'Uploading...',
        icon: <ImSpinner2 className="upload-spinner" />,
        className: 'upload-section-btn uploading',
        onClick: null,
        disabled: true
      }
    } else if (hasImage(section)) {
      return {
        text: 'Preview',
        icon: <img src={previewIcon} alt='Preview Icon' className='preview-icon' />,
        className: 'upload-section-btn preview-mode',
        onClick: () => openImageInNewTab(section),
        disabled: false
      }
    } else if (hasTemporaryPreview(section)) {
      return {
        text: 'Uploading..',
        icon: <ImSpinner2 className="upload-spinner" />,
        className: 'upload-section-btn uploading',
        onClick: null,
        disabled: true
      }
    } else {
      return {
        text: 'Upload',
        icon: <img src={uploadIcon} alt='upload icon' className="upload-icon" />,
        className: 'upload-section-btn',
        onClick: () => triggerFileInput(section),
        disabled: false
      }
    }
  }

  // Handle popstate
  useEffect(() => {
    const handlePopState = () => {
      navigate(`/claimlanding/${claimNumber}`, { replace: true })
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [navigate, claimNumber])

  // Clean up preview URLs
  useEffect(() => {
    return () => {
      Object.values(previewImages).forEach(url => {
        URL.revokeObjectURL(url);
      });
    };
  }, [previewImages]);

  return (
    <div className='survey-wrapper wrapper-doc-survey'>
      {/* Preview Modal */}
      {showPreviewModal && (
        <div className="preview-modal-overlay" onClick={closePreviewModal}>
          <div className="preview-modal-content" onClick={e => e.stopPropagation()}>
            <button className="preview-modal-close" onClick={closePreviewModal}>
              <FaTimes />
            </button>
            <img 
              src={selectedPreviewImage} 
              alt="Preview" 
              className="preview-modal-image"
            />
          </div>
        </div>
      )}

      {/* Main Content */}
      <>
        <div className='survey-container survey-doc-container'>
          <div className='survey-header'>
            <div className='survey-title'>
              <img
                src={ticket}
                alt='Company Logo'
                className='survey-logo'
              />
              <span>Upload Images</span>
            </div>
          </div>

          <div className='survey-sections survey-doc-section'>
            {sections.map((section, index) => {
              const buttonContent = getButtonContent(section)

              return (
                <div key={section} className='survey-item section-surveys'>
                  <span className='section-name'>{getDisplayName(section)}</span>
                  
                  <div className='icon-wrapper-sec'>
                    <button
                      className={buttonContent.className}
                      onClick={buttonContent.onClick}
                      disabled={buttonContent.disabled}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '4px 16px',
                        minWidth: '100px'
                      }}
                    >
                      {buttonContent.icon}
                      <span>{buttonContent.text}</span>
                    </button>

                    {/* Hidden file input */}
                    {!hasImage(section) && !isUploading(section) && !hasTemporaryPreview(section) && (
                      <input
                        type='file'
                        accept='image/*'
                        ref={el => fileInputRefs.current[section] = el}
                        style={{ display: 'none' }}
                        onChange={(e) => handleFileInputChange(e, section)}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </>
    </div>
  )
}

export default Uploaddocs